import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { Button, Typography } from '@/shared/components/atoms';
import routes from '@/shared/constant/routes';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import CheckMarkWithoutBG from '~/images/shared/CheckMarkWithoutBG.svg';
const CreatePropertySuccess: React.FC<{ entityId: number }> = ({
  entityId,
}) => {
  const { t } = useTranslation();

  const { push } = useRouter();

  const { closeModal } = useModal();

  const handleAddField = async () => {
    closeModal();
    push({
      pathname: `${routes.propertySettings}`,
      query: {
        tab: 3,
        id: entityId,
      },
    });
  };

  return (
    <div className='flex flex-col items-center justify-center gap-32 px-32'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-secondary-90 text-green-300'>
        <CheckMarkWithoutBG width='30' height='30' />
      </div>
      <div className=' max-w-sm text-center'>
        <Typography variant='h2' weight='medium'>
          {t('Your property is ready.')}
        </Typography>
        <Typography className='mt-8 text-surface-10'>
          {t(
            'Start adding your fields to streamline your operations and boost productivity, or dismiss this if you are not ready yet.'
          )}
        </Typography>
      </div>
      <div className='flex w-full gap-8'>
        <Button
          size='none'
          className='h-56 w-full !rounded-xl border-xs border-outline-default'
          variant='text'
          onClick={() => closeModal()}
        >
          {t('Dismiss')}
        </Button>
        <Button
          onClick={handleAddField}
          size='none'
          className='h-56 w-full !rounded-xl'
        >
          {t('Add Field')}
        </Button>
      </div>
    </div>
  );
};

export default CreatePropertySuccess;
